import type { CmsData, MenuType } from '../../../interfaces';
import { SchemaOrg } from '../SchemaOrg/SchemaOrg';
import { ContentWidth } from './ContentWidth';
import { ContentWithMenu } from './ContentWithMenu.client';
import { RegisteredCmsComponents } from './RegisteredCmsComponents';

export const Content = ({
  data,
  menuData,
  token,
}: {
  data: CmsData;
  menuData?: MenuType;
  token?: string;
}) => {
  const pageTemplate = data.type === 'storefront_content' ? 'homepage' : 'ServiceUndHilfe';

  const content = (
    <RegisteredCmsComponents
      paragraphs={data.paragraph}
      pageTemplate={pageTemplate}
      token={token}
    />
  );

  return (
    <ContentWidth contentWidth={data.field_maximum_content_width}>
      <SchemaOrg data={data} />
      {menuData ? (
        <ContentWithMenu menuData={menuData} currentPath={data.path?.[0].alias}>
          {content}
        </ContentWithMenu>
      ) : (
        content
      )}
    </ContentWidth>
  );
};
